import { Component } from '@angular/core';
import { of } from 'rxjs';
import { WebinarSettingsComponent } from '../webinar-settings/webinar-settings.component';
import { WebinarsService } from '../../../services/webinars/webinars.service';
import { ToastService } from '../../../services/layout/toast.service';
import { WebinarPropertyContext, WebinarSettings, WebinarSettingsInput } from '../../../models/webinar.model';

const binding = { clientId: 'fixture-client', connectionId: 'fixture-connection', portalId: '123' };
const settings: WebinarSettings = {
  id: binding.clientId,
  clientId: binding.clientId,
  hubspot: {
    enabled: true,
    registrationPropertyName: 'shine_webinars_latest_registration_id',
    additionalProperties: {
      ...binding,
      actions: {
        contactCreate: [{ propertyName: 'signup_source', value: 'shine_webinar' }],
        leadCreate: [{ propertyName: 'lead_source', value: 'webinar_poll' }],
        registrationContactCreate: [{ propertyName: 'signup_source', value: 'webinar_registration' }],
      },
    },
  },
  createdAt: null,
  updatedAt: null,
};

/** Render the real settings UI with synthetic services; reachable only through the localhost fixture guard. */
@Component({
  selector: 'app-webinar-settings-visual-fixture',
  standalone: true,
  imports: [WebinarSettingsComponent],
  template: '<app-webinar-settings></app-webinar-settings>',
  providers: [
    { provide: ToastService, useValue: { showSuccess: () => {}, showError: () => {} } },
    {
      provide: WebinarsService,
      useValue: {
        getHubspotStatus: () =>
          of({
            clientId: binding.clientId,
            connected: true,
            healthy: true,
            connections: [{ id: binding.connectionId }],
            supportsSetupValidation: true,
          }),
        getWebinarSettings: () => of(settings),
        updateWebinarSettings: (input: WebinarSettingsInput) =>
          of({ ...settings, ...input, hubspot: { ...settings.hubspot, ...input.hubspot } }),
        getHubspotWebinarPropertyContext: (objectType: 'contacts' | 'leads') =>
          of({
            ...binding,
            objectType,
            properties: [
              {
                name: objectType === 'leads' ? 'lead_source' : 'signup_source',
                label: 'Source',
                type: 'string',
                fieldType: 'text',
              },
              {
                name: 'customer_segment',
                label: 'Customer segment',
                type: 'enumeration',
                fieldType: 'select',
                options: [
                  { label: 'Business', value: 'business' },
                  { label: 'Consumer', value: 'consumer' },
                ],
              },
            ],
          } as WebinarPropertyContext),
      },
    },
  ],
})
export class WebinarSettingsVisualFixtureComponent {}
